// src/components/PrivateRoute.js

import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth0 } from "./react-auth0-spa";

import { authAppMetadataKey } from '../../config.js';
import CmtLoadingSpinner from '../common/CmtLoadingSpinner';

const PrivateRoute = ({ children }) => {
  const { loading, isAuthenticated, loginWithRedirect, user } = useAuth0();
  const customerKey = authAppMetadataKey + 'customerId';
  const location = useLocation();

  useEffect(() => {
    if (loading || isAuthenticated) {
      return;
    }
    const fn = async () => {
      await loginWithRedirect({
        appState: { targetUrl: location.pathname }
      });
    };
    fn();
  }, [loading, isAuthenticated, loginWithRedirect, location.pathname]);

  if (loading || !user) {
    return <CmtLoadingSpinner />;
  }

  if (isAuthenticated) {
    if (user.email_verified) {
      if (user[customerKey]) {
        return children;
      } else {
        if (location.pathname === '/signup') {
          return children;
        } else {
          return <Navigate to='/signup' replace />;
        }
      }
    } else {
      if (location.pathname.startsWith('/verifyemail')) {
        return children;
      } else {
        return <Navigate to={'/verifyemail?target=' + location.pathname} replace />;
      }
    }
  }

  return <CmtLoadingSpinner />;
};

export default PrivateRoute;
